import React, { useState } from 'react';
import css from './Sections.module.css';
import img1 from '../../../assets/curator1.png';
import img2 from '../../../assets/curator2.png';
import IconSearch from '../../../components/IconSearch/IconSearch';
import { FormattedMessage } from '../../../util/reactIntl';

function SectionShopByCurators({ intl, useHistoryPush }) {
  const [searchTerm, setSearchTerm] = useState('');

  const curatorItems = [
    {
      title: 'OmeDezin',
      image: img1,
    },
    {
      title: 'Kelly Wearstler',
      image: img2,
    },
  ];

  const handleSearch = e => {
    if (e.key === 'Enter' && searchTerm.trim()) {
      useHistoryPush('SearchPage', {}, { keywords: searchTerm });
    }
  };

  return (
    <div className={css.curatorsContainer}>
      <div className={css.sectionHead}>
        <h2>
          <FormattedMessage id="SectionShopByCurators.title" defaultMessage="Shop by curators" />
        </h2>
      </div>
      <div className={css.sectionContent}>
        <div className={css.curatorsContent}>
          {curatorItems.map(({ title, image }, index) => (
            <div key={index} className={css.curatorItem}>
              <div className={css.curatorImg}>
                <img src={image} alt={title} />
              </div>
              <div className={css.curatorInfo}>
                <h6>{title}</h6>
                <h2>{title}</h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionShopByCurators;
